module.exports = __webpack_public_path__ + "static/media/tab-3.af36e00a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/tab-3.png
// module id = 1253
// module chunks = 0